import React from "react";
import { news } from "../../constants";
import "./News.scss";
import Layout from "../../components/mainPage/Layout";
import { NewsItem } from "shared/components/NewsItem";

export function Page() {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="acticle-title" >
            Новости
          </h1>
          <p className="p-0 mb-4 w-100">
            В разделе представлены актуальные новости платформы, а также перечень
            последних обновлений
          </p>
          <div className="news__grid-container">
            {news.map((i) => (
              <NewsItem {...i} />

            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}


export const meta = {
  title: 'Новости',
  description: 'В разделе представлены актуальные новости платформы, а также перечень последних обновлений'
}

